export { OfficeBuilding as default } from './OfficeBuilding';
